import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(.52 .5)"
    }, [
      _createElementVNode("circle", {
        cx: "24.5",
        cy: "24.5",
        r: "23.734",
        fill: "#000",
        "fill-opacity": ".4",
        stroke: "currentColor",
        "stroke-width": "1.531"
      }),
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "m20.535 32.362 11.36-7.07-11.36-7.07z"
      })
    ], -1)
  ]))]))
}
export default { render: render }